import Elaborate from '@/images/icons/sia/elaborate.svg';
import MakeItDirect from '@/images/icons/sia/make-it-direct.svg';
import Professional from '@/images/icons/sia/professional.svg';
import ShortTextGrey from '@/images/icons/sia/short-text-grey.svg';

export const SIA_CONVERSATION_STYLES_VALUES = {
  CASUAL: 'casual',
  FORMAL: 'formal',
  NEUTRAL: 'neutral',
};

export const SIA_CONVERSATION_STYLES = [
  {
    label: 'Casual and Friendly',
    value: SIA_CONVERSATION_STYLES_VALUES.CASUAL,
  },
  {
    label: 'Formal and Professional',
    value: SIA_CONVERSATION_STYLES_VALUES.FORMAL,
  },
  {
    label: 'Informative and Neutral',
    value: SIA_CONVERSATION_STYLES_VALUES.NEUTRAL,
  },
];

export const MAX_FILESIZE_SIA_TRAINING_MATERIAL = 5;

export const SIA_FEATURE_FLAG_NAME = 'sia';

export const SIA_REGENERATE_INSTRUCTIONS = {
  SHORTEN: 'shorten',
  DIRECT: 'direct',
  PROFESSIONAL: 'professional',
  ELABORATE: 'elaborate',
};

export const SIA_REGENERATE_BASIC_OPTIONS = [
  {
    label: 'Make it Short',
    value: SIA_REGENERATE_INSTRUCTIONS.SHORTEN,
    icon: ShortTextGrey,
  },
  {
    label: 'Make it Direct',
    value: SIA_REGENERATE_INSTRUCTIONS.DIRECT,
    icon: MakeItDirect,
  },
  {
    label: 'Make it Professional',
    value: SIA_REGENERATE_INSTRUCTIONS.PROFESSIONAL,
    icon: Professional,
  },
  {
    label: 'Elaborate It',
    value: SIA_REGENERATE_INSTRUCTIONS.ELABORATE,
    icon: Elaborate,
  },
];

export const SIA_LOADING_TITLES = [
  'Let me think… just a sec…',
  'Using my brain…',
  'Just a sec…',
  'Summoning my brilliance…',
  'Plotting a perfect reply…',
  'Consulting the universe…',
  'In deep thought…',
];

export const SIA_PERSONALIZATION_STATUS = {
  NOT_STARTED: 'not_started',
  ONGOING: 'ongoing',
  COMPLETED: 'completed',
  FAILED: 'failed',
};

export const SIA_PERSONALIZATION_FAILED_REASON = {
  BRAND_GUIDELINES_FAILED: 'brand_guidelines_failed',
  WEBSITE_FAILED: 'website_scraping_failed',
};
